var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isshow)?_c('div',{staticClass:"radishdetail",staticStyle:{"width":"400px"}},[_c('div',{staticClass:"close",on:{"click":function($event){_vm.isshow = false}}},[_vm._v("X")]),_c('radishScoreInner',{ref:"radishScoreInner"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }